import { useTranslation } from 'react-i18next';

import type { PickerRow } from '@nucleus-commerce/admin-kit/resource-picker';
import type { StoreVariantPricing } from '@nucleus-commerce/api-client/admin';
import { useFormat } from '@nucleus-commerce/i18n/react';

/** A variant under its product in a store: its SKU and the store's effective price. */
export function useVariantRow() {
  const { t } = useTranslation('resourcePickers');
  const format = useFormat();
  return (variant: StoreVariantPricing): PickerRow => {
    const sellable = variant.isAvailable && variant.effective !== null;
    return {
      title: variant.title,
      description: variant.skuOverride ?? variant.sku ?? undefined,
      meta: variant.effective ? format.money(variant.effective) : null,
      ...(sellable
        ? {}
        : {
            disabled: variant.isAvailable ? t('variants.notPriced') : t('variants.unavailable'),
          }),
    };
  };
}
